module.exports = __webpack_public_path__ + "static/font-1bd55845930dedebdaa942af159e3fc6.woff";